module.exports = __webpack_public_path__ + "cement/img/组 4218@2x.b6c9c550.png";